import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import VisibilitySensor from 'react-visibility-sensor';

import gptw from "../../../../assets/img/home/hero/selo-large.webp";

import arrow from "../../../../assets/img/components/buttonBlue.webp";
import arrow2 from "../../../../assets/img/components/buttonBlue2.webp";
import { CButton, CForm, CFormInput, CFormLabel, CFormText, CFormSelect } from "@coreui/react-pro";
import { useAlert } from "src/contexts/AlertContext";
import { sendWarehouseServiceEmail } from "src/services/sendWarehouseServiceEmail";
import { trackLead, trackWhatsApp, buildWhatsAppText } from "src/utils/tracking";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";

import "swiper/css";

import arrowLeft from "../../../../assets/img/components/arrow-left.webp";
import arrowRight from "../../../../assets/img/components/arrow-right.webp";
import img1 from "../../../assets/img/landingPageThree/sectionSix/card1.webp";
import img2 from "../../../assets/img/landingPageThree/sectionSix/card2.webp";
import img3 from "../../../assets/img/landingPageThree/sectionSix/card3.webp";
import img4 from "../../../assets/img/landingPageThree/sectionSix/card4.webp";
import img5 from "../../../assets/img/landingPageThree/sectionSix/card5.webp";
import img6 from "../../../assets/img/landingPageThree/sectionSix/card6.webp";
import img7 from "../../../assets/img/landingPageThree/sectionSix/card7.webp";
import img8 from "../../../assets/img/landingPageThree/sectionSix/card8.webp";
import img9 from "../../../assets/img/landingPageThree/sectionSix/card9.webp";
import img10 from "../../../assets/img/landingPageThree/sectionSix/card10.webp";
import img11 from "../../../assets/img/landingPageThree/sectionSix/card11.webp";
import img12 from "../../../assets/img/landingPageThree/sectionSix/card12.webp";
import img13 from "../../../assets/img/landingPageThree/sectionSix/card13.webp";

const DEFAULT_FORM_DATA = {
    name: '',
    email: '',
    phone: '',
    city: '',
    service: '',
    load: '',
    isLoadingResponse: false
};

function SectionOne({message}){

    const [isVisible, setIsVisible] = useState(false);
    const { t } = useTranslation();

    const onChange = (visibility) => {
      if (visibility) {
        setIsVisible(true);
      }
    };

    const [formData, setFormData] = useState(DEFAULT_FORM_DATA)
    const [errors, setErrors] = useState({})

    const formatPhoneValue = (event) => {
    const formattedPhone = event.target.value
        .replace(/\D/g, '') // Remove todos os caracteres não numéricos
        .replace(/^(\d{2})(\d)/g, '($1) $2') // Adiciona parênteses em volta dos dois primeiros dígitos
        .replace(/(\d)(\d{4})$/, '$1-$2'); // Adiciona hífen entre o quinto e o sexto dígitos

    setFormData(prev => ({ ...prev, phone: formattedPhone }))
    }

    const {showAlert} = useAlert()

    const validateForm = () => {
        const newErrors = {}
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

        if (!formData.name || formData.name.trim().length < 3)
            newErrors.name = t("form_error_name")
        if (!formData.email || !emailRegex.test(formData.email.trim()))
            newErrors.email = t("form_error_email")
        if (!formData.phone || formData.phone.replace(/\D/g, "").length < 10)
            newErrors.phone = t("form_error_phone")

        setErrors(newErrors)
        return Object.keys(newErrors).length === 0
    }

    const handleSubmit = async () => {
        if (!validateForm()) return

        setFormData(prev => ({ ...prev, isLoadingResponse: true }))


        const response = await sendWarehouseServiceEmail(formData)

        if (response.success) {
            trackLead('lp_armazem', { service: formData.service, load: formData.load })
            setFormData(DEFAULT_FORM_DATA)
            setErrors({})
        }

        showAlert(response.message, response.success ? 'success' : 'error')
        setFormData(prev => ({ ...prev, isLoadingResponse: false }))
    }

    return(
        <VisibilitySensor onChange={onChange} partialVisibility minTopValue={200}>
            <div id="home" className="sectionOneBg">
                <video
                    autoPlay
                    muted
                    loop
                    playsInline
                    controlsList="disabled"
                    src={'https://singlec.com.br/imagens-publicas/gh_publicitario.mp4'}
                    preload="auto"
                ></video>
                <div className="sectionOne">
                    {/* <div className={`gptw ${isVisible ? 'visible' : ''}`} >
                        <img src={gptw} alt="" width={'60px'} height={'102px'}/>
                    </div> */}
                    <div className={`text ${isVisible ? 'visible' : ''}`}>
                        <h1>{t("lp3_hero_title")}</h1>
                        <h5>{t("lp3_hero_subtitle")}</h5>
                        <Swiper
                        slidesPerView={5}
                        spaceBetween={0}
                        autoplay={{
                            delay: 2500,
                            disableOnInteraction: false,
                        }}
                        navigation={{
                            nextEl: ".swiper-button-next",
                            prevEl: ".swiper-button-prev",
                        }}
                        speed={500}
                        loop={true}
                        modules={[Autoplay, Navigation]}
                        className={`mt-3 ${isVisible ? "visible" : ""}`}
                        >
                        <SwiperSlide>
                            <div className={`card1 card ${isVisible ? "visible" : ""}`}>
                            <img src={img1} alt="" />
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className={`card2 card ${isVisible ? "visible" : ""}`}>
                            <img src={img2} alt="" />
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className={`card3 card ${isVisible ? "visible" : ""}`}>
                            <img src={img3} alt="" />
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className={`card4 card ${isVisible ? "visible" : ""}`}>
                            <img src={img4} alt="" />
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className={`card5 card ${isVisible ? "visible" : ""}`}>
                            <img src={img5} alt="" />
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className={`card6 card ${isVisible ? "visible" : ""}`}>
                            <img src={img6} alt="" />
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className={`card7 card ${isVisible ? "visible" : ""}`}>
                            <img src={img7} alt="" />
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className={`card8 card ${isVisible ? "visible" : ""}`}>
                            <img src={img8} alt="" />
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className={`card9 card ${isVisible ? "visible" : ""}`}>
                            <img src={img9} alt="" />
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className={`card10 card ${isVisible ? "visible" : ""}`}>
                            <img src={img10} alt="" />
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className={`card11 card ${isVisible ? "visible" : ""}`}>
                            <img src={img11} alt="" />
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className={`card12 card ${isVisible ? "visible" : ""}`}>
                            <img src={img12} alt="" />
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className={`card13 card ${isVisible ? "visible" : ""}`}>
                            <img src={img13} alt="" />
                            </div>
                        </SwiperSlide>
                        </Swiper>
                        <a
                            className="button"
                            href={"https://wa.me/5547992246105?text=" + buildWhatsAppText(message)}
                            target="_blank"
                            rel="noreferrer"
                            reloadDocument
                            onClick={() => trackWhatsApp("lp_armazem_hero")}
                        >
                            <button>{t("lp3_hero_cta")}</button>
                        </a>
                    </div>
                    <CForm id="armazemForm" className={`${isVisible ? 'visible' : ''}`}>
                        <div>
                        <CFormLabel className="me-2 labelName">{t("lp3_form_name")}</CFormLabel>
                        <CFormInput
                            type="text"
                            maxLength={80}
                            minLength={3}
                            value={formData.name}
                            onChange={(e) => {
                                setFormData(prev => ({ ...prev, name: e.target.value }))
                                setErrors(prev => ({ ...prev, name: undefined }))
                            }}
                            className="me-2"
                            placeholder=""
                            invalid={!!errors.name}
                        ></CFormInput>
                        {errors.name && <CFormText className="text-danger">{errors.name}</CFormText>}
                        <CFormLabel>{t("lp3_form_email")}</CFormLabel>
                        <CFormInput
                            type="email"
                            autoComplete='off'
                            maxLength={60}
                            className="me-2"
                            placeholder=""
                            value={formData.email}
                            onChange={(e) => {
                                setFormData(prev => ({ ...prev, email: e.target.value }))
                                setErrors(prev => ({ ...prev, email: undefined }))
                            }}
                            invalid={!!errors.email}
                        ></CFormInput>
                        {errors.email && <CFormText className="text-danger">{errors.email}</CFormText>}
                        <CFormLabel>{t("lp3_form_phone")}</CFormLabel>
                        <CFormInput
                            type="phone"
                            autoComplete='off'
                            maxLength={15}
                            minLength={15}
                            onChange={(e) => {
                                formatPhoneValue(e)
                                setErrors(prev => ({ ...prev, phone: undefined }))
                            }}
                            className="me-2"
                            placeholder=""
                            value={formData.phone}
                            invalid={!!errors.phone}
                        ></CFormInput>
                        {errors.phone && <CFormText className="text-danger">{errors.phone}</CFormText>}
                        <CFormLabel>{t("lp3_form_city")}</CFormLabel>
                        <CFormInput
                            type="text"
                            autoComplete='off'
                            maxLength={40}
                            className="me-2"
                            placeholder=""
                            value={formData.city}
                            onChange={(e) => setFormData(prev => ({ ...prev, city: e.target.value }))}
                        ></CFormInput>
                        <CFormLabel>{t("lp3_form_service")}</CFormLabel>
                        <CFormSelect
                            aria-label={t("lp3_form_service")}
                            options={[
                                { label: '' },
                                { label: t("lp3_form_service_inhouse"), value: 'Operação in House' },
                                { label: t("lp3_form_service_controlled"), value: 'Operação com produtos controlados' },
                                { label: t("lp3_form_service_crossdocking"), value: 'Cross Docking' },
                                { label: t("lp3_form_service_picking"), value: 'Picking' },
                            ]}
                            value={formData.service}
                            onChange={(e) => setFormData(prev => ({ ...prev, service: e.target.value }))}
                        />
                        <CFormLabel>{t("lp3_form_load")}</CFormLabel>
                        <CFormSelect
                            aria-label={t("lp3_form_load")}
                            options={[
                                { label: '' },
                                { label: t("lp3_form_load_chemicals"), value: 'Químicos' },
                                { label: t("lp3_form_load_machinery"), value: 'Maquinários ou equipamentos' },
                                { label: t("lp3_form_load_agro"), value: 'Agronegócio' },
                                { label: t("lp3_form_load_electronics"), value: 'Eletrônicos' },
                                { label: t("lp3_form_load_food"), value: 'Alimentícios' },
                            ]}
                            value={formData.load}
                            onChange={(e) => setFormData(prev => ({ ...prev, load: e.target.value }))}
                        />
                        <CButton className="mt-4" onClick={handleSubmit} disabled={formData.isLoadingResponse}>
                            {formData.isLoadingResponse ? t("lp3_form_sending") : t("lp3_form_send")}
                        </CButton>
                        </div>
                    </CForm>
                </div>
                <img className={`arrow5 ${isVisible ? 'visible' : ''}`}  src={arrow2} width={'100px'} alt="" />
                <img className={`arrow6 ${isVisible ? 'visible' : ''}`} src={arrow2} width={'100px'} alt="" />
                <img className={`arrow7 ${isVisible ? 'visible' : ''}`} src={arrow} alt="" />
                <img className={`arrow8 ${isVisible ? 'visible' : ''}`} src={arrow} alt="" />
            </div>
        </VisibilitySensor>
    )
}

export default SectionOne;
